import { postAPICall } from './httpHelper';

export async function getAllSources() {
  try {
    let result = await postAPICall('GET', 'integrations/service/get-all-applications');
    return result.data;
  } catch (err) {
    console.error('Failed to fetch sources:', err);
    throw err;
  }
}
export function macthedApplicationWithKey(applications, application) {
  return applications.find((app) => app.key === application);
}
export function macthedEvent(application, value) {
  return application.events.find((event) => event.eventKey === value);
}
export async function getRealData(payload) {
  try {
    const response = await postAPICall('POST', 'integrations/service/fetch-data', payload);
    return response.data;
  } catch (err) {
    console.error('Failed to fetch data:', err);
    throw err;
  }
}
export async function getIntegrationInfo(id) {
  try {
    const response = await postAPICall(
      'GET',
      `integrations/service/get-tokens-by-connection/${id}`
    );
    return response.data;
  } catch (err) {
    console.log('Err', err);
    throw err;
  }
}
